import React, { useState } from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useRequestContainerStyles } from '../styles';
import MotiveList from './MotiveList';

const RequestContainer = ({ ...props }) => {
  const { requests, mobile } = props;
  const classes = useRequestContainerStyles({ mobile });

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box width="100%" marginTop={1} className={classes.boxContainer}>
      {requests?.map((request, index) => (
        <React.Fragment key={index}>
          <Accordion
            onChange={handleChange(index)}
            expanded={expanded === index}
            elevation={0}
            className={classes.accordion}
            width="100%"
          >
            <AccordionSummary
              className={classes.accordionSummary}
              data-cy={request.dataCy}
              expandIcon={
                <ExpandMoreIcon
                  className={classes.arrowExpandIcon}
                  fontWeight={100}
                />
              }
            >
              <Box display="flex" alignItems="center">
                <img src={request.icon} className={classes.icon} />
                <Box display="flex" flexDirection="column">
                  <Typography className={classes.title}>
                    {request.title}
                  </Typography>
                  <Typography className={classes.subtitle}>
                    {request.subtitle}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <MotiveList motives={request.motives} mobile={mobile} />
            </AccordionDetails>
          </Accordion>
          <Divider />
        </React.Fragment>
      ))}
    </Box>
  );
};

RequestContainer.propTypes = {
  mobile: PropTypes.bool,
  requests: PropTypes.array,
};

export default RequestContainer;
